import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import app from '@/components/app/app.vue'
import { ClientTable, ServerTable } from 'vue-tables-2'
import VuejsDialog from 'vuejs-dialog'
import Notifications from 'vue-notification'
import VeeValidate from 'vee-validate'
import VTooltip from 'v-tooltip'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.use(VTooltip)
Vue.use(VeeValidate, { events: '' })
Vue.use(Notifications)
Vue.use(ClientTable)
Vue.use(ServerTable)
Vue.use(VuejsDialog)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: (h) => h(app)
})



// WEBPACK FOOTER //
// ./src/main.js